import { Bell, Bot, Database, Workflow } from "lucide-react";
import { cn } from "@/lib/utils";

/** Illustrative agency view for the hero (sample data, not live). */
const MOCK_CLIENTS = [
  { name: "Sample Client A", app: "Support bot", balance: "$184.20", earned: "$96.40", low: false },
  { name: "Sample Client B", app: "Contract Q&A", balance: "$62.75", earned: "$51.10", low: false },
  { name: "Sample Client C", app: "Lead agent", balance: "$4.10", earned: "$23.85", low: true },
  { name: "Sample Client D", app: "Onboarding flow", balance: "$310.00", earned: "$118.60", low: false },
];

const MOCK_APPS = [
  { model: "rag:kb-support@anthropic/claude-sonnet-5-5", icon: Database },
  { model: "agent:lead-qualifier", icon: Bot },
  { model: "langgraph:onboarding", icon: Workflow },
];

export function HeroMock() {
  return (
    <div className="rounded-card bg-card p-2 sm:p-3">
      <div className="rounded-[16px] bg-surface-muted/70 p-2 grid gap-2 lg:grid-cols-[minmax(0,1fr)_280px]">
        {/* Client accounts */}
        <div className="rounded-[16px] bg-card p-5 sm:p-6 min-w-0">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <p className="text-[13px] text-muted-foreground">Clients</p>
              <p className="text-lg font-medium mt-1">4 client accounts</p>
            </div>
            <span className="inline-flex items-center h-7 rounded-full border border-border px-3 text-xs text-muted-foreground">
              Sample data
            </span>
          </div>

          <div className="mt-6 overflow-x-auto">
            <table className="w-full min-w-[460px] text-[13px]">
              <thead>
                <tr className="text-left text-muted-foreground">
                  <th className="font-normal pb-3">Client</th>
                  <th className="font-normal pb-3">App</th>
                  <th className="font-normal pb-3 text-right">Wallet</th>
                  <th className="font-normal pb-3 text-right">Your markup earned</th>
                </tr>
              </thead>
              <tbody>
                {MOCK_CLIENTS.map((c) => (
                  <tr key={c.name} className="border-t border-border/60">
                    <td className="py-3 pr-3">
                      <span className="inline-flex items-center gap-2.5">
                        <span className="h-7 w-7 rounded-full bg-surface-muted flex items-center justify-center text-[11px] font-semibold text-foreground/80" aria-hidden>
                          {c.name.slice(-1)}
                        </span>
                        {c.name}
                      </span>
                    </td>
                    <td className="py-3 pr-3 text-muted-foreground">{c.app}</td>
                    <td className={cn("py-3 text-right tabular", c.low && "text-warning")}>
                      {c.low && <Bell className="inline h-3.5 w-3.5 mr-1 -mt-0.5" strokeWidth={1.7} aria-label="Low balance" />}
                      {c.balance}
                    </td>
                    <td className="py-3 text-right tabular text-success">+{c.earned}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Side tiles */}
        <div className="grid gap-2 grid-cols-2 lg:grid-cols-1">
          <div className="rounded-[16px] bg-card p-5">
            <p className="text-[13px] text-muted-foreground">Markup earned this month</p>
            <p className="text-[28px] leading-none font-medium tracking-tight tabular mt-2">$289.95</p>
            <p className="text-xs text-muted-foreground mt-2">Credited to your agency wallet</p>
          </div>
          <div className="rounded-[16px] bg-card p-5">
            <p className="text-[13px] text-muted-foreground">Your markup</p>
            <p className="text-[28px] leading-none font-medium tracking-tight tabular mt-2">20%</p>
            <p className="text-xs text-muted-foreground mt-2">Added to every client request</p>
          </div>
          <div className="rounded-[16px] bg-card p-5 col-span-2 lg:col-span-1 min-w-0">
            <p className="text-[13px] text-muted-foreground">Built once, used by every client</p>
            <ul className="mt-3 grid gap-2">
              {MOCK_APPS.map(({ model, icon: Icon }) => (
                <li key={model} className="flex items-center gap-2 min-w-0">
                  <span className="h-7 w-7 shrink-0 rounded-[10px] bg-surface-muted flex items-center justify-center">
                    <Icon className="h-3.5 w-3.5" strokeWidth={1.7} />
                  </span>
                  <code className="font-fragment text-[12px] truncate">{model}</code>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
